export const rootOption = "add";
export const organisationalUnit = "ORGANISATIONAL_UNIT";
export const alwaysOpenBranch = ["add", "move"];
